import clsx from 'clsx'

import { PhoneNumberField, TextField } from '@fv/client-components'

import { InputGroup } from './InputGroup'

type ContactPhoneValues = {
  contactPhone: string
  contactPhoneExt?: string
}

type Props = {
  className?: string
  disabled?: boolean
  label?: string
  name: string
  onChange: (values: ContactPhoneValues) => void
  readOnly?: boolean
  required?: boolean
  values: ContactPhoneValues
  hideExt?: boolean
}

export const ContactPhoneInput = ({
  className,
  disabled,
  label = 'Contact phone',
  name,
  onChange,
  readOnly,
  required,
  values,
  hideExt,
}: Props) => {
  const { contactPhone, contactPhoneExt } = values
  const extensionName = `${name}Ext`

  return (
    <div className={clsx('form-group mb-0 flex [&>*]:p-0', className)}>
      <InputGroup
        inputProps={{ name }}
        inputType="custom"
        label={label}
        className="flex-1"
        required={required}
      >
        <PhoneNumberField
          name={name}
          className="form-control min-w-[8.5rem]"
          disabled={disabled}
          onChange={e =>
            onChange({
              contactPhone: e.target.value,
              contactPhoneExt: contactPhoneExt ?? '',
            })
          }
          readOnly={readOnly}
          required={required}
          value={contactPhone}
        />
      </InputGroup>

      {!hideExt && (
        <div className="-ml-px w-16">
          <label htmlFor={extensionName} className="label">
            Ext
          </label>
          <TextField
            className="form-control"
            name={extensionName}
            onChange={e => {
              onChange({
                contactPhone,
                contactPhoneExt: e.target.value.replace(/\D/g, ''),
              })
            }}
            pattern="\d*"
            disabled={disabled}
            readOnly={readOnly}
            value={contactPhoneExt}
          />
        </div>
      )}
    </div>
  )
}
